module.exports = __webpack_public_path__ + "media/ppp/ab_news_list/placeholder-b39206eef7f55098f16af060cdb209b2.svg";